import React, { useState } from 'react';

function ReadMoreText({ children, maxChars = 20, allowExpand = true }) {
  const [expanded, setExpanded] = useState(false);

  if (!children || typeof children !== 'string') return children;

  const shouldTruncate = children.length > maxChars;
  const displayText =
    expanded || !shouldTruncate
      ? `${children} `
      : `${children.slice(0, maxChars)}... `;

  return (
    <>
      {displayText}
      {shouldTruncate && allowExpand && (
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          style={{
            background: 'none',
            padding: 0,
            border: 'none',
            color: '#1976d2',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}>
          {expanded ? 'less' : 'more'}
        </button>
      )}
    </>
  );
}

export default ReadMoreText;
